export const enum GUIDED_FLOW {
  INTAKE = 'INTAKE',
  ONBOARDING = 'ONBOARDING',
  ACCOUNT_SETUP = 'ACCOUNT_SETUP',
  PRE_REVIEW_CHECK_IN = 'PRE_REVIEW_CHECK_IN',
}

export const GUIDED_FLOW_MAX_WIDTH = 512;
export const QUESTION_SPACING_IN_UNITS = 4;
